import React from 'react';

const AddCircleOutline = ({ width = 16, height = 16, color = '#424242' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke={color} />
      <path
        d="M8.00049 5.18994V10.8114"
        stroke={color}
        strokeWidth="1.20459"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1875 7.99915H10.8089"
        stroke={color}
        strokeWidth="1.20459"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AddCircleOutline;
